import HcmConditionAutocomplete from './HcmConditionAutocomplete';
import { friendlyLabel } from './bpmConditionHelpers';

const OPERATOR_PHRASE = {
  equals: 'equals',
  not_equals: 'does not equal',
  contains: 'contains',
};

export function buildConditionDescription(condition) {
  const col = condition?.column;
  if (!col) return condition?.description || '';
  const label = friendlyLabel(col);
  const op = OPERATOR_PHRASE[condition?.operator] || 'equals';
  const val = condition?.value != null ? String(condition.value).trim() : '';
  if (!val) return `If ${label} …`;
  return `If ${label} ${op} ${val}`;
}

/**
 * Single BPM approval condition row with HCM-aware autocomplete.
 */
export default function BpmConditionEditor({
  condition,
  onChange,
  disabled = false,
  transactionCategory = '',
}) {
  const description = buildConditionDescription(condition);

  return (
    <div className="rounded-lg border border-cyan-200 bg-cyan-50/30 p-3 space-y-2">
      <div>
        <p className="text-[11px] font-semibold uppercase tracking-wide text-cyan-900">
          Approval condition
        </p>
      </div>
      <HcmConditionAutocomplete
        value={condition || {}}
        onChange={onChange}
        disabled={disabled}
        bpmCategory={transactionCategory}
      />
      {description && (
        <p className="text-xs text-cyan-950 rounded-md bg-white/80 border border-cyan-100 px-2 py-1.5">
          <span className="font-medium text-cyan-900">Preview: </span>
          {description}
        </p>
      )}
    </div>
  );
}
